import { listenToExportJobProgress, type ExportJobProgressPayload } from 'packages/services/exportService';
import type { SseSubscribeOptions } from '../useSseSubscribe';

type Options = SseSubscribeOptions<ExportJobProgressPayload>;

export function sseByJobIdExportJobsOptions({
    jobId,
    onMessage,
}: {
    jobId: number;
    onMessage: Options['onMessage'];
}): Options {
    return {
        deps: [jobId],
        subscribe: (onData, onClose) => listenToExportJobProgress(jobId, onData, onClose),
        onMessage,
    };
}
